<template>
	<div class="form__login">
		<div class="form__login__fields">
			<p class="form__login__message">
				{{ $t('linkRecuperacaoSenha') }}
			</p>
		</div>
		<Button
			semantic-class="mini"
			label="Voltar para login"
			@click="setStep('login')"
		/>
		<p>
			Não recebeu?
			<span @click="setStep('recover')">{{ $t('cliqueParaReenviar') }}</span>
		</p>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
export default {
	components: { Button },
	props: {
		setStep: Function,
	},
}
</script>

<style scoped>
.form__login {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
}

.form__login__fields {
	display: flex;
	flex-direction: column;
	padding-top: 3.21rem;
	padding-bottom: 3.75rem;
	width: 100%;
	justify-content: space-between;
}

.form__login__message {
	font-size: 1rem;
	color: var(--color-navy-blue);
	font-weight: bold;
	text-align: center;
}

p {
	margin-top: 0.62rem;
	font-size: 0.75rem;
}

p span {
	font-weight: bold;
	cursor: pointer;
}
</style>
